import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var css = {
  "textField": "rui-O0HLU",
  "inputContainer": "rui-qTa0R",
  "animatedPlaceholder": "rui-Q1LXq",
  "fill": "rui-PLYGk",
  "icon": "rui-ZXuqY",
  "errorIcon": "rui-ZRgu3",
  "disabled": "rui-1SvJf",
  "error": "rui-hC0oY",
  "hint": "rui-PJmhs",
  "hintContainer": "rui-Rz0Rk",
  "lengthCounter": "rui-4dWrE"
};
import classNames from 'classnames';
var icons = {
  "panameraIcons": "rui-CXaZ2",
  "icon-download": "rui-8dADt",
  "icon-arrow-top-left": "rui-WhWIZ",
  "icon-SMS": "rui-9ycrb",
  "icon-more": "rui-RoGpD",
  "icon-circle_stroke": "rui-o40gR",
  "icon-Approved": "rui-0o6Oa",
  "icon-CreditCard": "rui-VjaE1",
  "icon-Cash": "rui-soluw",
  "icon-OK": "rui-Nsj4Z",
  "icon-Tips": "rui-cmNxY",
  "icon-ArrowRight": "rui-FoRP5",
  "icon-ArrowLeft": "rui-gl7Ni",
  "icon-ArrowDown": "rui-oKXO0",
  "icon-ArrowUp": "rui-VwnlQ",
  "icon-Cross": "rui-wKCT9",
  "icon-Menu": "rui-OGAFJ",
  "icon-Location": "rui-BCmOe",
  "icon-Crosshairs": "rui-V6LKP",
  "icon-Classes": "rui-OhNfW",
  "icon-Electronics": "rui-Oeixo",
  "icon-FavoriteOff": "rui-OOUzL",
  "icon-FavoriteOn": "rui-EdJCX",
  "icon-Facebook": "rui-990kR",
  "icon-FacebookProfile": "rui-IQ0fc",
  "icon-FacebookProfileValidated": "rui-Wu3Ns",
  "icon-SendMessage": "rui-lgETM",
  "icon-GoogleProfile": "rui-8yTHq",
  "icon-Zoom": "rui-99cag",
  "icon-GoogleProfileValidated": "rui-qudbD",
  "icon-MakeAnOffer": "rui-X8H5d",
  "icon-Flag": "rui-0nl5f",
  "icon-ShareIt": "rui-bSEwF",
  "icon-PhoneProfile": "rui-Wi0Wu",
  "icon-Back": "rui-XRg9H",
  "icon-PhoneProfileValidated": "rui-2AXnM",
  "icon-Whatsapp": "rui-zIPW5",
  "icon-Messenger": "rui-YtAcL",
  "icon-Home": "rui-0iBIX",
  "icon-Industries": "rui-qt5M6",
  "icon-Instruments": "rui-772Ga",
  "icon-Jobs": "rui-oXsZw",
  "icon-Games": "rui-3CRNc",
  "icon-Animals": "rui-HbcoW",
  "icon-Farming": "rui-7zveZ",
  "icon-Fashion": "rui-EY9uj",
  "icon-RealEstate": "rui-Lm3Dx",
  "icon-Services": "rui-Mn0FQ",
  "icon-ForSale": "rui-Vp6WE",
  "icon-Smartphones": "rui-CdgZ5",
  "icon-Sports": "rui-pmYnj",
  "icon-Furnitures": "rui-QDPYG",
  "icon-Vehicles": "rui-N2xlq",
  "icon-Babies": "rui-uXA4a",
  "icon-Exit": "rui-jVSLp",
  "icon-Edit": "rui-qj8rz",
  "icon-Trash": "rui-AoGmv",
  "icon-Search": "rui-fLpAi",
  "icon-Notifications": "rui-QbqhH",
  "icon-Photo": "rui-IXSRQ",
  "icon-Hot": "rui-oAerh",
  "icon-View": "rui-M7sCx",
  "icon-Chat": "rui-Qq5hb",
  "icon-User": "rui-zoRm8",
  "icon-UserCheck": "rui-hDRqw",
  "icon-Friends": "rui-aoTzZ",
  "icon-Refresh": "rui-UmMHL",
  "icon-ErrorHaired": "rui-NfS0U",
  "icon-OKHaired": "rui-djZy7",
  "icon-AddPhotos": "rui-xL1XO",
  "icon-CrossRounded": "rui-0DkO8",
  "icon-OLX": "rui-4M6XE",
  "icon-EyeOff": "rui-gt2eK",
  "icon-DoubleCheckRead": "rui-qUzGV",
  "icon-attach": "rui-RzBhd",
  "icon-offer": "rui-9rU35",
  "icon-meeting": "rui-xAzJd",
  "icon-iconcategories": "rui-PppAb",
  "icon-sorting": "rui-AQGEL",
  "icon-mobileFilters": "rui-CeN5A",
  "icon-bigView": "rui-xA1mo",
  "icon-gridView": "rui-vhoTR",
  "icon-listView": "rui-ls11x",
  "icon-mic": "rui-JorSl",
  "icon-play": "rui-osBMh",
  "icon-pause": "rui-zGaZx",
  "icon-myads": "rui-TbOkM",
  "icon-unfollow-friend": "rui-QJlAD",
  "icon-call": "rui-pJxSV",
  "icon-twotone-more1": "rui-KgnD4",
  "icon-twotone-nearby": "rui-oYNLf",
  "icon-twotone-sale": "rui-smtGS",
  "icon-twotone-rent": "rui-siMW9",
  "icon-YoutubeProfile": "rui-iE9k9",
  "icon-TwitterProfile": "rui-uvABe",
  "icon-InstagramProfile": "rui-NNOLS",
  "icon-Key": "rui-EykPp",
  "icon-Inventory": "rui-tueft",
  "icon-Draft": "rui-HnQzh",
  "icon-Addcar": "rui-f5omG",
  "icon-Lift": "rui-1oRvV",
  "icon-CarParking": "rui-MLygQ",
  "icon-CCTV": "rui-a0Odn",
  "icon-ClubHouse": "rui-lDwCK",
  "icon-FireAlarm": "rui-iZpAU",
  "icon-Fitness": "rui-3XVWI",
  "icon-Intercom": "rui-PwebR",
  "icon-PlayArea": "rui-AZYPO",
  "icon-PowerBackup": "rui-M6nct",
  "icon-RainWater": "rui-oCoYR",
  "icon-Security": "rui-vgfBT",
  "icon-SwimmingPool": "rui-RWbSj",
  "icon-WaterSupply": "rui-TGTwu",
  "icon-twotone-motorbike": "rui-z6RNS",
  "icon-AttentionHaired": "rui-MH8VD",
  "icon-AddFriend": "rui-0W12u",
  "icon-Filters": "rui-Wv5dr",
  "icon-help-outline": "rui-NRFlq",
  "icon-PremiumFeaturedAd": "rui-IYUBp"
};
var TextField = /*#__PURE__*/function (_React$Component) {
  function TextField(props) {
    var _this;
    _classCallCheck(this, TextField);
    _this = _callSuper(this, TextField, [props]);
    _this.input = null;
    _this.componentDidUpdate = function (prevProps) {
      var _a, _b;
      var prevIsInvalid = prevProps.isInvalid,
        prevValue = prevProps.value;
      var _this$props = _this.props,
        isInvalid = _this$props.isInvalid,
        value = _this$props.value,
        name = _this$props.name;
      if (isInvalid !== prevIsInvalid) {
        (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.value, name);
      }
      if (value !== prevValue) {
        _this.setState({
          value: value
        });
      }
    };
    _this.inputChange = function (event) {
      var _a, _b;
      if (_this.props.type === 'number') {
        if (event.target.validity.valid) {
          _this.setState({
            value: event.target.value
          }, function () {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.value, _this.props.name);
          });
        } else if (event.target.value === '') {
          _this.input.value = '';
          (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.value, _this.props.name);
        }
      } else {
        _this.setState({
          value: event.target.value
        }, function () {
          var _a, _b;
          (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.value, _this.props.name);
        });
      }
    };
    _this.inputFocus = function (event) {
      var _a, _b;
      (_b = (_a = _this.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };
    _this.inputBlur = function (event) {
      var _a, _b;
      (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event, _this.state.value, _this.props.name);
    };
    _this.inputKeyUp = function (event) {
      if (!event.target.validity.valid) {
        _this.input.value = '';
      }
    };
    _this.inputKeyDown = function (event) {
      var _a, _b;
      (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };
    _this.state = {
      value: props.value
    };
    return _this;
  }
  _inherits(TextField, _React$Component);
  return _createClass(TextField, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var icon;
      if (this.props.icon) {
        icon = /*#__PURE__*/React.createElement("div", {
          className: "".concat(css.icon, " ").concat(icons.panameraIcons, " ").concat(icons[this.props.icon]),
          onClick: this.props.iconClick,
          onKeyPress: this.props.iconClick,
          tabIndex: 0,
          role: "button"
        });
      }
      if (this.props.errorText) {
        icon = /*#__PURE__*/React.createElement("div", {
          className: "".concat(css.errorIcon, " ").concat(icons.panameraIcons, " ").concat(icons['icon-AttentionHaired']),
          onClick: this.props.iconClick,
          onKeyPress: this.props.iconClick,
          tabIndex: 0,
          role: "button"
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classNames([css.textField, this.props.className, this.props.errorText ? css.error : '', this.props.disabled ? css.disabled : '']),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: css.inputContainer
      }, /*#__PURE__*/React.createElement("input", Object.assign({
        id: this.props.id,
        name: this.props.name,
        type: this.props.type,
        value: this.state.value,
        onChange: this.inputChange,
        onFocus: this.inputFocus,
        onBlur: this.inputBlur,
        onKeyDown: this.inputKeyDown,
        onKeyUp: this.inputKeyUp,
        disabled: this.props.disabled,
        className: "".concat(this.state.value && this.state.value.toString().length ? css.fill : ''),
        ref: function ref(input) {
          return _this2.input = input;
        },
        autoFocus: this.props.autoFocus,
        maxLength: this.props.maxLength
      }, this.props.extras)), /*#__PURE__*/React.createElement("label", {
        className: css.animatedPlaceholder
      }, this.props.label)), /*#__PURE__*/React.createElement("div", {
        className: css.hintContainer
      }, !this.props.errorText && /*#__PURE__*/React.createElement("span", {
        className: css.hint,
        "data-aut-id": "hint_".concat(this.props.name)
      }, this.props.hintText), /*#__PURE__*/React.createElement("span", {
        className: css.error,
        "data-aut-id": "error_".concat(this.props.name)
      }, this.props.errorText), this.props.maxLength && /*#__PURE__*/React.createElement("span", {
        className: css.lengthCounter,
        "data-aut-id": "lengthCounter_".concat(this.props.name)
      }, "".concat(this.state.value.length, " / ").concat(this.props.maxLength))), icon);
    }
  }]);
}(React.Component);
TextField.defaultProps = {
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  type: 'text',
  value: '',
  label: '',
  errorText: '',
  isInvalid: false,
  className: '',
  id: '',
  name: '',
  icon: '',
  iconClick: function iconClick() {},
  disabled: false,
  style: {},
  autoFocus: false,
  extras: {}
};
export default TextField;